import { XMarkIcon } from "@heroicons/react/24/solid";
import LoadingInComponent from "../LoadingInComponent";
import Button from "../Button";
import {
  ArrowLeft2,
  Call,
  Coffee,
  ExportCircle,
  ImportCircle,
  Sms,
} from "iconsax-react";
import SectionCard from "../SectionCard";
import TextboxSet from "../TextboxSet";
import GroupMemberListing from "./GroupMemberListing";
import { UPDATE_GUEST_NOTE_API } from "../../Constant/api";
import { useToast } from "../Toast";
import axios from "axios";
import { useState } from "react";
import TableGuestList from "../TableGuestList";

const CheckInSliderStep2 = ({
  guestInfo,
  handleOnChange,
  groupMembers,
  loading,
  setIsOpen,
  setStep,
  handleCheckIn,
  handleCheckOut,
  handleRecordClick,
  onSelectTableGuest,
}) => {
  const [innerLoading, setInnerLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { toast } = useToast();
  const toggleModal = () => setShowModal(!showModal);

  const handleUpdateGuestNote = () => {
    setInnerLoading(true);
    axios
      .put(
        UPDATE_GUEST_NOTE_API,
        {
          guestId: guestInfo.id,
          note: guestInfo.note,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
        }
      )
      .then((res) => {
        setInnerLoading(false);
        toast("Note updated successfully", "success");
      })
      .catch((error) => {
        setInnerLoading(false);
        console.error(error);
        toast(error.response.data.message, "error");
      });
  };

  return (
    <div className="absolute right-0 top-0 flex flex-col bg-white w-full h-screen no-scrollbar overflow-y-auto">
      <TableGuestList
        guestInfo={guestInfo}
        isOpen={showModal}
        toggleModal={toggleModal}
        onSelectGuest={(guestUuid) => {
          onSelectTableGuest(guestUuid);
        }}
      />

      <LoadingInComponent isLoading={loading}>
        <div className="flex flex-col w-full p-[24px] gap-[24px] bg-white">
          <div className="flex w-full justify-between">
            {setStep && (
              <Button variant="secondary" onClick={() => setStep(1)}>
                <ArrowLeft2 size="16" />
                Back
              </Button>
            )}
            <XMarkIcon
              className="size-[24px] hover:cursor-pointer"
              onClick={() => setIsOpen(false)}
            />
          </div>
          <div className="flex flex-col items-center justify-center gap-[24px]">
            {/* Table Name */}
            <div
              className={`flex flex-col border border-[#EFF0F2] rounded-xl justify-center items-center py-[12px] px-[41px] ${
                guestInfo.table_name ? "cursor-pointer hover:bg-[#F7F8F9]" : ""
              }`}
              onClick={() => {
                if (guestInfo.table_name) toggleModal();
              }}
            >
              <p className="text-[11px] font-normal">Table</p>
              <h1 className="text-[42px]">
                {guestInfo.table_name ? guestInfo.table_name : "No table"}
              </h1>
            </div>

            {/* Guest details */}
            <div className="flex flex-col w-full items-center justify-center gap-[16px]">
              <div className="flex flex-col items-center justify-center">
                {guestInfo.tags && guestInfo.tags.length > 0 && (
                  <div className="flex flex-wrap gap-[4px]">
                    {guestInfo.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="text-[11px] font-medium px-[8px] py-[4px] rounded-md"
                        style={{
                          backgroundColor: tag.color + "30",
                          color: tag.color,
                        }}
                      >
                        {tag.name}
                      </span>
                    ))}
                  </div>
                )}
                <h2 className="w-full text-center text-[17px]">
                  {guestInfo.salutation && `${guestInfo.salutation}. `}
                  {guestInfo.name}
                </h2>
              </div>
              <div className="w-[8px] border border-[#A1A7B2]" />
              <div className="flex flex-wrap w-full gap-[8px] justify-center text-[#636C7E]">
                <div className="flex gap-[4px] items-center text-[12px] font-normal">
                  <Sms size="12" variant="Bold" />
                  {guestInfo.email ? guestInfo.email : "None"}
                </div>
                <div className="flex gap-[4px] items-center text-[12px] font-normal">
                  <Call size="12" variant="Bold" />
                  {guestInfo.contact ? guestInfo.contact : "None"}
                </div>
                <div className="flex gap-[4px] items-center text-[12px] font-normal">
                  <Coffee size="12" variant="Bold" />
                  {guestInfo.dietary_name ? guestInfo.dietary_name : "None"}
                </div>
                <div className="flex gap-[4px] items-center text-[12px] font-normal">
                  <Coffee size="12" variant="Bold" />
                  {guestInfo.group_name ? guestInfo.group_name : "None"}
                </div>
              </div>
            </div>

            {/* Buttons */}
            {handleCheckIn && handleCheckOut && (
              <div className="flex w-full justify-center">
                {guestInfo.status ? (
                  <Button
                    variant="error"
                    onClick={() => handleCheckOut({ id: guestInfo.id })}
                  >
                    <ExportCircle size="16" variant="Outline" />
                    Check Out
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    onClick={() => handleCheckIn({ id: guestInfo.id })}
                  >
                    <ImportCircle size="16" variant="Outline" />
                    Check In
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col w-full p-[24px] gap-[24px]">
          <SectionCard title="Notes" collapsible>
            <LoadingInComponent isLoading={innerLoading}>
              <div className="flex flex-col gap-4 m-[24px]">
                <TextboxSet
                  type="textarea"
                  name="note"
                  value={guestInfo.note}
                  onChange={handleOnChange}
                />
                <Button
                  onClick={handleUpdateGuestNote}
                  disabled={innerLoading || loading}
                >
                  Update Note
                </Button>
              </div>
            </LoadingInComponent>
          </SectionCard>
          <GroupMemberListing
            members={groupMembers}
            handleCheckIn={handleCheckIn}
            handleCheckOut={handleCheckOut}
            handleMemberClick={handleRecordClick}
          />
        </div>
      </LoadingInComponent>
    </div>
  );
};

export default CheckInSliderStep2;
